import { z } from 'zod';

/**
 * Single source of truth for env vars.
 * Validated at module load; throws loud and early if misconfigured.
 *
 * All client-side vars MUST be prefixed with VITE_ to be exposed by Vite.
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
  VITE_SITE_URL: z.string().url().default('http://localhost:31100'),
  VITE_ENABLE_QUERY_DEVTOOLS: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('❌ Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables — see console for details.');
}

export const env = {
  apiBaseUrl: parsed.data.VITE_API_BASE_URL,
  siteUrl: parsed.data.VITE_SITE_URL,
  enableQueryDevtools: parsed.data.VITE_ENABLE_QUERY_DEVTOOLS,
  isProd: import.meta.env.PROD,
  isDev: import.meta.env.DEV,
} as const;
